import jQuery from 'jquery'
(function($) {
    $(function() {
        /**
         * Makes sure, cookie consent banner is displayed, when user
         * didn't already click it.
         *
         * Based on @see https://codeshack.io/eu-cookie-consent-popup-javascript/?PageSpeed=noscript
         */
        if (!localStorage.getItem('cookieconsent')) {
            var $cookieConsent = $('.cookie-consent');
            $cookieConsent.removeClass('closed');

            $cookieConsent.find('.got-it').click(function(e) {
                e.preventDefault();
                $cookieConsent.addClass('closed');
                localStorage.setItem('cookieconsent', true);
            });
        }
    });
})(jQuery);
